import { useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { useIntercom } from "react-use-intercom";
import { UserContext } from "../../contexts/UserContext";

export const IntercomIntegration = () => {
  const location = useLocation();
  const { userDetails } = useContext(UserContext);

  // Intercom integration
  const { update, shutdown, boot } = useIntercom();

  // handle log in and log out
  useEffect(() => {
    // authenticated (i.e. logged into the app)
    if (userDetails?.id) {
      boot({
        userId: userDetails?.id,
        email: userDetails?.email,
        hideDefaultLauncher: true,
      });
    }

    // unauthenticated (e.g. on the sign-in page)
    else {
      shutdown();
      // we still boot intercom (as an anonymous user), as the user can
      // request help from some pages.
      boot({
        hideDefaultLauncher: true,
      });
    }
  }, [boot, shutdown, userDetails?.email, userDetails?.id]);

  // handle route changes
  useEffect(() => {
    update({
      userId: userDetails?.id,
      email: userDetails?.email,
      hideDefaultLauncher: true,
    });
  }, [location.pathname, update, userDetails?.email, userDetails?.id]);

  return null;
};
